import {
  EditCPBankAccount,
  PayerBankAccountsSynchronization,
} from "@/models/api/administration/contractors/PayerBankAccountsSynchronization";
import CancellableHelper from "@/requests/CancellableHelper";

//#region routes
export const URL_GET_PAYER_BANK_ACCOUNTS = "/ContractorAdministration/${ContractorId}/CPBankAccounts";
export const URL_POST_ADD_PAYER_BANK_ACCOUNT = "/ContractorAdministration/${ContractorId}/AddCPBankAccount";
export const URL_POST_EDIT_PAYER_BANK_ACCOUNT = "/ContractorAdministration/${BankAccountId}/EditCPBankAccount";
export const URL_POST_SYNC_PAYER_BANK_ACCOUNTS = "/ContractorAdministration/${ContractorId}/SyncCPBankAccounts";

//#endregion

const _getPayerBankAccounts = new CancellableHelper<PayerBankAccountsSynchronization>(
  URL_GET_PAYER_BANK_ACCOUNTS,
  PayerBankAccountsSynchronization
);
export const getPayerBankAccounts = async (contractorId: string): Promise<PayerBankAccountsSynchronization> => {
  return _getPayerBankAccounts.get({ ContractorId: contractorId });
};

const _postAddPayerBankAccount = new CancellableHelper<void>(URL_POST_ADD_PAYER_BANK_ACCOUNT, null, true);
export const postAddPayerBankAccount = async (contractorId: string, model: EditCPBankAccount): Promise<void> => {
  return _postAddPayerBankAccount.post({ ContractorId: contractorId }, model);
};

const _postEditPayerBankAccount = new CancellableHelper<void>(URL_POST_EDIT_PAYER_BANK_ACCOUNT, null, true);
export const postEditPayerBankAccount = async (bankAccountId: number, model: EditCPBankAccount): Promise<void> => {
  return _postEditPayerBankAccount.post({ BankAccountId: bankAccountId }, model);
};

const _postSyncPayerBankAccounts = new CancellableHelper<void>(URL_POST_SYNC_PAYER_BANK_ACCOUNTS, null, true);
export const postSyncPayerBankAccounts = async (contractorId: string): Promise<void> => {
  return _postSyncPayerBankAccounts.post({ ContractorId: contractorId }, null);
};
